import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-about-section',
  templateUrl: './about-section.component.html',
  styleUrls: ['./about-section.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AboutSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
